export const SET_TOKEN_STRING = 'SET_TOKEN_STRING';
export const SET_TOKEN_EXPIRE_AT = 'SET_TOKEN_EXPIRE_AT';
export const SET_TOKEN_ACCOUNT_NO = 'SET_TOKEN_ACCOUNT_NO';